"use strict";

var __assign = this && this.__assign || Object.assign || function (t) {
  for (var s, i = 1, n = arguments.length; i < n; i++) {
    s = arguments[i];

    for (var p in s) {
      if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
  }

  return t;
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
  }
  return t;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = require("react");

var font_1 = require("@headspace/hs-web-style-guide/dist/font");

var styles_1 = require("./styles");

function SelectField(props) {
  var onChange = props.onChange,
      children = props.children,
      value = props.value,
      _a = props.id,
      id = _a === void 0 ? '' : _a,
      _b = props.width,
      width = _b === void 0 ? 150 : _b;
  return React.createElement("select", __assign({
    className: "selectField"
  }, styles_1.selectFieldStyle(width), styles_1.selectFieldTextStyle, {
    onChange: onChange,
    value: value
  }), children);
}

exports.SelectField = SelectField;

function SelectOption(props) {
  var value = props.value,
      inheritedProps = __rest(props, ["value"]);

  return React.createElement("option", __assign({
    className: "selectOption",
    value: value
  }, styles_1.selectOptionStyle, font_1.regular, inheritedProps));
}

exports.SelectOption = SelectOption;